import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

/**
 * Primary UI component for user interaction
 */
export const Icon = ({ name }) => {
    switch (name) {
        case 'timer':
            return (
                <svg width="39" height="44" viewBox="0 0 39 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M25.8667 1C25.8667 0.447716 25.4189 0 24.8667 0H14.4C13.8477 0 13.4 0.447715 13.4 1V3.15556C13.4 3.70784 13.8477 4.15556 14.4 4.15556H24.8667C25.4189 4.15556 25.8667 3.70784 25.8667 3.15556V1ZM17.5555 26.0111C17.5555 26.5634 18.0033 27.0111 18.5555 27.0111H20.7111C21.2634 27.0111 21.7111 26.5634 21.7111 26.0111V15.5444C21.7111 14.9922 21.2634 14.5444 20.7111 14.5444H18.5555C18.0033 14.5444 17.5555 14.9922 17.5555 15.5444V26.0111ZM34.2401 13.277L36.5411 10.976C36.9083 10.6088 36.9349 10.0199 36.5867 9.63452C36.0664 9.05896 35.5202 8.5072 34.948 7.99014C34.5659 7.64488 33.983 7.67473 33.6189 8.03887L31.3104 10.3473C28.0899 7.77089 24.0382 6.23333 19.6333 6.23333C9.30676 6.23333 0.933319 14.6068 0.933319 24.9333C0.933319 35.2599 9.28599 43.6333 19.6333 43.6333C29.9807 43.6333 38.3333 35.2599 38.3333 24.9333C38.3333 20.5284 36.7958 16.4768 34.2401 13.277ZM19.6333 39.4778C11.5923 39.4778 5.08887 32.9743 5.08887 24.9333C5.08887 16.8923 11.5923 10.3889 19.6333 10.3889C27.6743 10.3889 34.1778 16.8923 34.1778 24.9333C34.1778 32.9743 27.6743 39.4778 19.6333 39.4778Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'secure':
            return (
                <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.1156 14.2167C11.2632 10.8008 12.4402 8.35398 14.0147 6.74453C15.7139 5.00759 17.9829 4.13333 20.2667 4.13333C22.5504 4.13333 24.8195 5.00759 26.5186 6.74453C28.0931 8.35398 29.2702 10.8008 29.4177 14.2167H11.1156ZM7.44625 14.2167C7.59827 9.93262 9.08383 6.54158 11.3936 4.18044C13.8195 1.70073 17.0504 0.466664 20.2667 0.466667C23.4829 0.466667 26.7139 1.70073 29.1397 4.18044C31.4495 6.54158 32.9351 9.93262 33.0871 14.2167H37.1333C38.7534 14.2167 40.0667 15.53 40.0667 17.15V37.6834C40.0667 39.3034 38.7534 40.6167 37.1333 40.6167H3.40001C1.77997 40.6167 0.466675 39.3034 0.466675 37.6834V17.15C0.466675 15.53 1.77997 14.2167 3.40001 14.2167H7.44625ZM4.13334 36.95V17.8834H36.4V36.95H4.13334ZM18.0667 23.75C18.0667 22.535 19.0516 21.55 20.2667 21.55C21.4817 21.55 22.4667 22.535 22.4667 23.75V26.6831C23.3573 27.352 23.9333 28.4171 23.9333 29.6167C23.9333 31.6417 22.2917 33.2834 20.2667 33.2834C18.2416 33.2834 16.6 31.6417 16.6 29.6167C16.6 28.4171 17.1761 27.352 18.0667 26.6831V23.75Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'questions':
            return (
                <svg width="21" height="40" viewBox="0 0 21 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.274871 5.5556C0.990911 6.96932 2.77986 7.30692 4.23452 6.67823C5.20251 6.25987 6.12299 6.09971 7.22144 6.09971C10.5645 6.09971 12.8519 8.32844 12.8519 11.5542C12.8519 13.8416 12.2068 15.132 9.15692 19.2375C6.63493 22.6393 5.31536 23.9752 5.31536 26.0867C5.31536 27.4976 6.595 28.5631 8.00589 28.5631H8.12459C9.63227 28.5631 10.8425 27.3745 11.3445 25.9528C11.8491 24.5238 12.6938 23.1354 13.9077 21.7009L17.0162 17.8886C19.0103 15.4839 20.1247 12.7273 20.1247 10.0293C20.1247 4.39883 15.3739 0 9.09827 0C5.93137 0 3.53345 0.728519 0.963132 2.52177C-0.00673635 3.19842 -0.259471 4.50062 0.274871 5.5556ZM8.10121 31.9062C5.75516 31.9062 4.05428 33.607 4.05428 35.9531C4.05428 38.2991 5.75516 40 8.10121 40C10.4472 40 12.1481 38.2991 12.1481 35.9531C12.1481 33.607 10.4472 31.9062 8.10121 31.9062Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'info-round':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 41C32.4934 41 41 32.4934 41 22C41 11.5066 32.4934 3 22 3C11.5066 3 3 11.5066 3 22C3 32.4934 11.5066 41 22 41ZM22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z"
                        fill="currentColor"
                    />
                    <path
                        d="M21.9402 7C20.2287 7 19 8.22875 19 9.89633C19 11.6078 20.2287 12.8365 21.9402 12.8365C23.6078 12.8365 24.8365 11.6078 24.8365 9.89633C24.8365 8.22875 23.6078 7 21.9402 7ZM24.3099 16.9962C24.3099 16.4439 23.8622 15.9962 23.3099 15.9962H20.2633C19.711 15.9962 19.2633 16.4439 19.2633 16.9962V34.7C19.2633 35.2523 19.711 35.7 20.2633 35.7H23.3099C23.8622 35.7 24.3099 35.2523 24.3099 34.7V16.9962Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'tick-round':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
                        fill="#5F2478"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.7678 13.8284C36.1583 14.219 36.1583 14.8521 35.7678 15.2426L17.4142 33.5962C17.0237 33.9867 16.3905 33.9867 16 33.5962L7.70711 25.3033C7.31658 24.9128 7.31658 24.2796 7.70711 23.8891L9.82843 21.7678C10.219 21.3772 10.8521 21.3772 11.2426 21.7678L16 26.5251C16.3905 26.9157 17.0237 26.9157 17.4142 26.5251L32.2322 11.7071C32.6228 11.3166 33.2559 11.3166 33.6464 11.7071L35.7678 13.8284Z"
                        fill="white"
                    />
                </svg>
            );
        case 'tick':
            return (
                <svg width="41" height="31" viewBox="0 0 41 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M40.0015 3.06792C40.5476 3.61403 40.533 4.50383 39.9693 5.03178L13.2238 30.0816C12.6856 30.5857 11.8446 30.5719 11.3232 30.0505L0.966379 19.6937C0.432662 19.16 0.432662 18.2946 0.966379 17.7609L3.10008 15.6272C3.63379 15.0935 4.49912 15.0935 5.03284 15.6272L11.3284 21.9228C11.8477 22.4421 12.6846 22.4582 13.2235 21.9591L35.9686 0.893721C36.5074 0.394688 37.3443 0.410725 37.8636 0.930036L40.0015 3.06792Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'tick-big':
            return (
                <svg width="51" height="40" viewBox="0 0 51 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M50.2949 5.39973C50.6854 5.79025 50.6854 6.42341 50.2949 6.81394L17.5648 39.5441C17.1743 39.9346 16.5411 39.9346 16.1506 39.5441L0.797988 24.1914C0.407464 23.8009 0.407465 23.1678 0.797989 22.7772L5.49061 18.0846C5.88113 17.6941 6.5143 17.6941 6.90482 18.0846L16.1506 27.3304C16.5411 27.7209 17.1743 27.7209 17.5648 27.3304L44.1881 0.707107C44.5786 0.316583 45.2118 0.316583 45.6023 0.707108L50.2949 5.39973Z"
                        fill="white"
                    />
                </svg>
            );
        case 'small-tick':
            return (
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5.5 4.103 9 11 1" stroke="#000" strokeWidth="2" />
                </svg>
            );
        case 'move-more':
            return (
                <svg width="19" height="43" viewBox="0 0 19 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.14 17.642C4.525 19.926.361 26.04 1.502 41.417v.005c.076.674.639 1.203 1.32 1.203H2.938a1.363 1.363 0 0 0 1.204-1.429v-.003c-.328-4.204-.213-7.647.13-10.45l8.213 11.25.002.003c.261.337.639.527 1.054.527.295 0 .563-.075.795-.266.599-.451.71-1.242.298-1.842l-.002-.003L4.938 27.18c1.19-4.907 3.226-7.04 4.285-7.86l3.532 4.024-3.637 3.604a1.31 1.31 0 0 0 0 1.85l.003.003c.522.484 1.35.527 1.88-.003l5.36-5.291.084-.084-.08-.089-3.243-3.584-3.24-3.58a1.058 1.058 0 0 0-.456-.343c-2.143-.986-3.768-1.987-4.85-2.98-1.085-.996-1.61-1.971-1.594-2.91.016-.765.377-1.53.96-2.269.582-.738 1.379-1.438 2.248-2.07 1.74-1.264 3.752-2.24 4.87-2.682a1.31 1.31 0 0 0 .755-1.697 1.31 1.31 0 0 0-1.698-.754C9.633.654 7.242 1.64 4.952 3.252 2.67 4.86.446 7.118.377 9.862v.001c-.07 2.877 2.258 5.476 6.762 7.779Zm6.094-12.295A5.317 5.317 0 0 0 7.93 10.65a5.317 5.317 0 0 0 5.304 5.305 5.317 5.317 0 0 0 5.304-5.305 5.317 5.317 0 0 0-5.304-5.304ZM10.56 10.65a2.687 2.687 0 0 1 2.674-2.674 2.687 2.687 0 0 1 2.674 2.674 2.687 2.687 0 0 1-2.674 2.674 2.687 2.687 0 0 1-2.674-2.674Z"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth=".25"
                    />
                </svg>
            );
        case 'lose-weight':
            return (
                <svg width="40" height="42" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.0269 10.1818C16.0269 12.633 18.0067 14.6128 20.4579 14.6128C22.8619 14.6128 24.8417 12.633 24.8417 10.1818C24.8417 7.73067 22.8619 5.75087 20.4107 5.75087C19.6094 5.75087 18.8552 5.98656 18.1952 6.36366L21.2121 9.52191C21.6363 9.99329 21.6363 10.7475 21.165 11.2189C20.9764 11.4546 20.6936 11.5488 20.3636 11.5488H20.3165C19.9865 11.5488 19.7037 11.4074 19.468 11.1717C19.3737 11.0303 19.2794 10.8889 19.2323 10.7475L17.7239 6.69363C16.6868 7.49498 16.0269 8.7677 16.0269 10.1818Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.872 42C38.0404 42 39.8316 40.1616 39.8316 37.8519V11.2189C39.8316 9.09764 38.0875 7.40067 35.872 7.40067H30.0741C28.8485 3.11111 24.8889 0 20.4579 0C16.0269 0 12.0202 3.11111 10.8417 7.40067H4.00673C2.02694 7.40067 0 8.81482 0 11.2189V37.8519C0 40.1145 1.83838 42 4.00673 42H35.872ZM28.9427 10.1347H35.872C36.8148 10.1347 37.0505 11.0303 37.0976 11.2189V37.8519C37.0976 38.559 36.532 39.2189 35.9192 39.2189H4.05383C3.34676 39.2189 2.82825 38.5118 2.82825 37.8519V11.1717C2.82825 10.6061 3.34676 10.1347 4.05383 10.1347H12.0673C12.7272 10.1347 13.34 9.61619 13.4343 8.95625C13.9057 5.51518 17.1111 2.73403 20.505 2.73403C23.899 2.73403 27.0572 5.51518 27.5757 8.95625C27.67 9.61619 28.2357 10.1347 28.9427 10.1347Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'quit-smoking':
            return (
                <svg width="43" height="36" viewBox="0 0 43 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.8666 0.875256L19.8666 0.875063L19.8597 0.875041C16.346 0.863934 13.8033 3.10481 12.6916 4.322C12.2802 4.77246 12.3508 5.44338 12.7812 5.85184C13.2859 6.33073 14.0873 6.28456 14.5872 5.82378C15.1951 5.26338 16.0348 4.59035 16.9437 4.07218C17.8556 3.55233 18.8214 3.19743 19.6865 3.25146L19.6893 3.25157C20.878 3.29906 22.2586 3.68332 23.2489 5.19042L23.2559 5.20115L23.265 5.21022C23.3463 5.29144 23.3873 5.37175 23.4358 5.46868L23.4356 5.46879L23.4394 5.47541C23.9732 6.39629 24.4872 7.16612 25.0534 7.63032C25.3386 7.86413 25.6415 8.02432 25.971 8.08506C26.3015 8.14597 26.6493 8.10506 27.0204 7.95171C27.7149 7.66468 29.2224 7.18332 30.916 7.01499C32.6123 6.84639 34.4731 6.99402 35.8943 7.94023L35.8949 7.94062C37.6514 9.09586 39.2267 11.447 39.4894 14.7057C39.544 15.3839 40.0883 15.9521 40.7836 15.9521C41.5108 15.9521 42.087 15.3266 42.0083 14.6002C41.7585 12.2965 41.3972 10.7532 40.7493 9.51572C40.1003 8.27608 39.1695 7.35463 37.8044 6.28418L37.8046 6.2839L37.7968 6.2787C34.0996 3.8009 29.3575 4.35557 26.4695 5.26394C26.4527 5.23973 26.4355 5.21695 26.4201 5.19637L26.4169 5.19218C26.3788 5.14141 26.3499 5.10227 26.3316 5.06582L26.3279 5.05837L26.3232 5.05148C24.5602 2.45926 22.3922 1.02362 19.8666 0.875256ZM34.1361 24.9999H29.4996L23.3598 20.7887H34.1361C34.6194 20.7887 35.0111 21.1805 35.0111 21.6637V24.1249C35.0111 24.6081 34.6194 24.9999 34.1361 24.9999ZM13.9437 18.2431H4.31345C3.13985 18.2431 2.18845 19.1945 2.18845 20.3681V25.5175C2.18845 26.6911 3.13985 27.6425 4.31345 27.6425H27.7491L38.3769 34.8785C39.1388 35.3972 40.1817 35.1473 40.6257 34.3397C41.0128 33.6356 40.8029 32.7527 40.1403 32.2982L33.3525 27.6425H35.533C36.7066 27.6425 37.658 26.6911 37.658 25.5175V20.3681C37.658 19.1945 36.7066 18.2431 35.533 18.2431H19.6484L3.01902 6.83721C2.26465 6.31979 1.23279 6.51961 0.726102 7.28122C0.228228 8.02957 0.425545 9.03925 1.16853 9.54511L13.9437 18.2431ZM17.6826 20.7887L23.8677 24.9999H5.66173C5.17848 24.9999 4.78673 24.6081 4.78673 24.1249V21.6637C4.78673 21.1805 5.17848 20.7887 5.66173 20.7887H17.6826ZM40.8259 27.6425C41.5434 27.6425 42.125 27.0609 42.125 26.3434V19.5422C42.125 18.8247 41.5434 18.2431 40.8259 18.2431C40.1084 18.2431 39.5267 18.8247 39.5267 19.5422V26.3434C39.5267 27.0609 40.1084 27.6425 40.8259 27.6425Z"
                        fill="currentColor"
                        strokeWidth="0.25"
                    />
                </svg>
            );
        case 'drink-less':
            return (
                <svg width="33" height="40" viewBox="0 0 33 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.0774 26.3721C23.7054 25.4419 27.7054 23.0233 29.9844 19.1628C34.4495 11.5814 30.4495 1.44186 30.2635 0.976745C30.0395 0.388645 29.4755 0 28.8462 0H4.6326C3.79577 0 3.04742 0.520985 2.75695 1.30578L2.5 2C-0.244185 9.90698 0.403039 15.3023 3.70536 19.907C7.0542 24.6047 12.3565 26 15.0077 26.4186V36.9302H6.33327C5.78098 36.9302 5.33327 37.3779 5.33327 37.9302V39C5.33327 39.5523 5.78099 40 6.33327 40H26.7519C27.3042 40 27.7519 39.5523 27.7519 39V37.9302C27.7519 37.3779 27.3042 36.9302 26.7519 36.9302H18.0774V26.3721ZM6.21698 18.093C3.89372 14.8232 3.48071 10.28 5.01473 4.57367C5.24159 3.72979 6.0209 3.16276 6.89475 3.16276H26.2382C27.1114 3.16276 27.8899 3.72626 28.109 4.57156C28.9204 7.703 29.8158 13.3136 27.2868 17.5814C25.3798 20.7907 21.7519 22.7907 16.4961 23.4418C15.7984 23.3953 9.56582 22.7907 6.21698 18.093Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'move-more-round':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M22 0C9.83833 0 0 9.86701 0 22C0 34.1617 9.83833 44 22 44C34.1617 44 44 34.1617 44 22C44 9.86701 34.1617 0 22 0ZM21.455 19.7627C20.5658 20.4224 18.7588 22.2295 17.7262 26.5319L25.9009 37.6897C26.2164 38.1486 26.1304 38.751 25.6714 39.0952C25.4993 39.2386 25.2986 39.296 25.0691 39.296C24.7536 39.296 24.4668 39.1525 24.266 38.8944L17.2099 29.2282C16.8944 31.6375 16.7797 34.6206 17.0665 38.292C17.0952 38.837 16.6936 39.3246 16.1486 39.382C16.1199 39.382 16.0913 39.382 16.0626 39.382C15.5463 39.382 15.116 38.9804 15.0587 38.4641C14.0834 25.3272 17.7262 20.279 19.8774 18.472C16.0052 16.5215 14.0548 14.3416 14.1121 11.9609C14.2269 7.45763 21.4263 4.47458 22.2295 4.15906C22.7458 3.95828 23.3194 4.21643 23.5202 4.73272C23.721 5.24902 23.4628 5.82269 22.9465 6.02347C21.0535 6.76923 16.1486 9.32203 16.0913 12.0183C16.0626 13.6819 17.9557 15.4029 21.5698 17.0665C21.7132 17.1239 21.8279 17.2099 21.914 17.3246L27.3638 23.3481L22.8605 27.794C22.4589 28.1956 21.8279 28.1669 21.4263 27.794C21.0248 27.3924 21.0535 26.7614 21.4263 26.3885L24.5528 23.2907L21.455 19.7627ZM24.811 16.837C22.4876 16.837 20.6232 14.9439 20.6232 12.6493C20.6232 10.3546 22.5163 8.46154 24.811 8.46154C27.1343 8.46154 28.9987 10.3546 28.9987 12.6493C28.9987 14.9439 27.1056 16.837 24.811 16.837Z"
                        fill="#26ACB5"
                    />
                </svg>
            );
        case 'lose-weight-round':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="22" cy="22" rx="22" ry="22" fill="white" />
                    <path
                        d="M31.7809 14.9153H27.5645C27.1343 14.9153 26.7901 14.5998 26.7327 14.1982C26.4172 12.1043 24.4954 10.412 22.4302 10.412C20.365 10.412 18.4146 12.1043 18.1278 14.1982C18.0704 14.5998 17.6975 14.9153 17.2959 14.9153H12.4198C11.9895 14.9153 11.674 15.2021 11.674 15.5463V31.781C11.674 32.1825 11.9895 32.6128 12.4198 32.6128H31.8096C32.1825 32.6128 32.5267 32.2112 32.5267 31.781V15.575C32.498 15.4603 32.3546 14.9153 31.7809 14.9153ZM22.4016 17.6402C20.91 17.6402 19.7053 16.4355 19.7053 14.944C19.7053 14.0835 20.1069 13.309 20.7379 12.8214L21.6558 15.2882C21.6845 15.3742 21.7418 15.4603 21.7992 15.5463C21.9426 15.6897 22.1147 15.7758 22.3155 15.7758C22.3155 15.7758 22.3155 15.7758 22.3442 15.7758C22.545 15.7758 22.7171 15.7184 22.8318 15.575C23.1186 15.2882 23.1186 14.8292 22.8605 14.5424L21.0248 12.6206C21.4263 12.3912 21.8852 12.2477 22.3729 12.2477C23.8644 12.2477 25.0691 13.4524 25.0691 14.944C25.0691 16.4355 23.8644 17.6402 22.4016 17.6402Z"
                        fill="#26ACB5"
                    />
                    <path
                        d="M22 0C9.83833 0 0 9.83833 0 22C0 34.1617 9.83833 44 22 44C34.1617 44 44 34.1617 44 22C44 9.83833 34.1617 0 22 0ZM34.1904 31.781C34.1904 33.1864 33.1004 34.3051 31.781 34.3051H12.3911C11.0717 34.3051 9.95307 33.1578 9.95307 31.781V15.575C9.95307 14.1121 11.1864 13.2516 12.3911 13.2516H16.5502C17.2673 10.6415 19.7054 8.74837 22.4016 8.74837C25.0978 8.74837 27.5072 10.6415 28.2529 13.2516H31.781C33.1291 13.2516 34.1904 14.2842 34.1904 15.575V31.781V31.781Z"
                        fill="#26ACB5"
                    />
                </svg>
            );
        case 'quit-smoking-round':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="22" cy="22" rx="22" ry="22" fill="white" />
                    <path
                        d="M21.0672 21.2404H29.7639H31.6582H31.6869V27.6899H31.6582H30.3379L40.0965 34.4834C42.5649 30.929 44 26.6293 44 21.9857C44 9.83192 34.1552 0 21.9857 0C14.5232 0 7.95044 3.69772 3.96088 9.37329L21.0672 21.2404ZM34.3275 27.6899H32.4331V21.2404H34.3275V27.6899ZM21.2394 10.7492C22.7032 10.8352 23.9661 11.6665 24.9993 13.1857C25.028 13.243 25.0855 13.3003 25.1142 13.3577C26.8076 12.813 29.6204 12.4691 31.8017 13.9309C33.6673 15.1922 34.5858 17.3993 34.5571 20.4951L32.2609 20.4665C32.2896 18.1733 31.6869 16.5967 30.5101 15.8228C28.788 14.6762 26.2335 15.3355 25.4012 15.6795C24.5688 16.0235 23.8226 15.6795 23.1911 14.5902C23.1624 14.5329 23.1337 14.4756 23.0763 14.4182C22.4736 13.501 21.8421 13.0423 21.1246 13.0137C19.7469 12.9277 18.197 14.3896 17.7665 14.9055L16.0157 13.415C16.2166 13.1283 18.484 10.5772 21.2394 10.7492Z"
                        fill="#26ACB5"
                    />
                    <path d="M29.7638 25.7694V23.1322H23.7939L27.6112 25.7694H29.7638Z" fill="#26ACB5" />
                    <path d="M12.2557 23.1322V25.7694H24.3966L20.6079 23.1322H12.2557Z" fill="#26ACB5" />
                    <path
                        d="M27.152 27.6899H12.2557H10.3614V25.798V23.1609V21.269H12.2557H17.8526L2.985 10.9498C1.09067 14.1889 0 17.9726 0 22.0143C0 34.1681 9.84475 44 22.0143 44C28.8741 44 34.9876 40.8756 39.0059 35.9739L27.152 27.6899Z"
                        fill="#26ACB5"
                    />
                </svg>
            );
        case 'drink-less-round':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="22" cy="22" rx="22" ry="22" fill="white" />
                    <path
                        d="M15.1734 12.5345C13.94 16.4641 14.1121 19.5619 15.661 21.7418C17.7262 24.6388 21.5697 25.0117 22 25.0404C25.2412 24.6388 27.4785 23.4055 28.6545 21.4263C30.4902 18.3285 29.4003 14.0834 28.9126 12.5345H15.1734Z"
                        fill="#26ACB5"
                    />
                    <path
                        d="M22 0C9.83833 0 0 9.83833 0 22C0 34.1617 9.83833 44 22 44C34.1617 44 44 34.1617 44 22C44 9.83833 34.133 0 22 0ZM30.3181 22.4016C28.9126 24.7823 26.4459 26.2738 22.9752 26.8475V33.3585H28.9413V35.2516H15.116V33.3585H21.0821V26.8761C19.4472 26.618 16.1773 25.7575 14.1121 22.8605C12.0756 20.0209 11.9035 16.1199 13.5958 11.2438L13.8253 10.5841H30.2608L30.4902 11.1864C30.605 11.4733 33.0717 17.7262 30.3181 22.4016Z"
                        fill="#26ACB5"
                    />
                </svg>
            );
        case 'form-error':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M41 22C41 32.4934 32.4934 41 22 41C11.5066 41 3 32.4934 3 22C3 11.5066 11.5066 3 22 3C32.4934 3 41 11.5066 41 22ZM44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22ZM24.1596 8.75005C24.7245 8.75005 25.1773 9.21773 25.159 9.7824L24.6398 25.8224C24.6223 26.3618 24.18 26.7901 23.6403 26.7901H20.3589C19.8192 26.7901 19.3768 26.3618 19.3594 25.8224L18.8401 9.7824C18.8219 9.21773 19.2746 8.75005 19.8396 8.75005H24.1596ZM25.3067 31.8174C25.2813 33.6456 23.7452 35.1182 22.0059 35.1182C20.1778 35.1182 18.6798 33.6456 18.7052 31.8174C18.6798 30.0147 20.1778 28.5547 22.0059 28.5547C23.7452 28.5547 25.2813 30.0147 25.3067 31.8174Z"
                        fill="#A1201F"
                    />
                </svg>
            );
        case 'loading':
            return (
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 1.6665V1.02715C8 0.12637 6.90243 -0.315193 6.27861 0.334616L4.66483 2.01564C4.29335 2.4026 4.29335 3.01374 4.66483 3.4007L6.27861 5.08172C6.90243 5.73153 8 5.28997 8 4.38919V3.74984C11.31 3.74984 14 6.55192 14 9.99984C14 10.7956 13.857 11.5616 13.5926 12.2617C13.441 12.6629 13.4999 13.1248 13.797 13.4342L13.8601 13.5C14.3147 13.9735 15.0964 13.8863 15.3483 13.2802C15.7658 12.2753 16 11.1668 16 9.99984C16 5.39567 12.42 1.6665 8 1.6665ZM8 16.2498C4.69 16.2498 2 13.4478 2 9.99984C2 9.20406 2.14303 8.43808 2.40745 7.73796C2.55899 7.33672 2.50006 6.8749 2.20303 6.5655L2.13987 6.4997C1.68533 6.02622 0.903582 6.1134 0.65173 6.71951C0.234196 7.72434 0 8.83292 0 9.99984C0 14.604 3.58 18.3332 8 18.3332V18.9725C8 19.8733 9.09757 20.3149 9.72139 19.6651L11.3352 17.984C11.7067 17.5971 11.7067 16.9859 11.3352 16.599L9.72139 14.9179C9.09757 14.2681 8 14.7097 8 15.6105V16.2498Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'chevron':
            return (
                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.598708 2.56519C0.208184 2.17466 0.208184 1.5415 0.598708 1.15097L0.775485 0.974197C1.16601 0.583672 1.79917 0.583673 2.1897 0.974197L7.29249 6.07699C7.68301 6.46751 8.31618 6.46751 8.7067 6.07699L13.8095 0.974197C14.2 0.583672 14.8332 0.583672 15.2237 0.974197L15.4005 1.15097C15.791 1.5415 15.791 2.17466 15.4005 2.56519L8.7067 9.25897C8.31618 9.64949 7.68301 9.64949 7.29249 9.25897L0.598708 2.56519Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'nav-button':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="22" cy="22" r="22" fill="#5F2478" />
                    <line
                        x1="14.0766"
                        y1="14.6581"
                        x2="30.8215"
                        y2="14.6581"
                        stroke="white"
                        strokeWidth="3.0102"
                        strokeLinecap="round"
                    />
                    <line
                        x1="14.0766"
                        y1="21.8418"
                        x2="30.8215"
                        y2="21.8418"
                        stroke="white"
                        strokeWidth="3.0102"
                        strokeLinecap="round"
                    />
                    <line
                        x1="14.0766"
                        y1="29.0255"
                        x2="30.8215"
                        y2="29.0255"
                        stroke="white"
                        strokeWidth="3.0102"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case 'exit-button':
            return (
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="22" cy="22" r="22" fill="#5F2478" />
                    <line
                        x1="16.1285"
                        y1="16"
                        x2="27.969"
                        y2="27.8404"
                        stroke="white"
                        strokeWidth="3.0102"
                        strokeLinecap="round"
                    />
                    <line
                        x1="16"
                        y1="27.8405"
                        x2="27.8404"
                        y2="16"
                        stroke="white"
                        strokeWidth="3.0102"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case 'minus':
            return (
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.5 10.5h14"
                        stroke="currentColor"
                        strokeWidth="2.637"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case 'plus':
            return (
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.5 3.5v14m-7-7h14"
                        stroke="currentColor"
                        strokeWidth="2.637"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case 'beer-bottle':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path
                        d="M30.634 19.99v20.314s.207 2.59-2.187 2.59h-8.893c-2.394 0-2.188-2.59-2.188-2.59V19.99c.06-1.452 1.987-2.252 1.987-2.252.414-.19.664-1.18.664-1.18l1.94-9.408c0-.231-.51-.59-.51-.59V5.99h5.102v.569s-.506.359-.506.59l1.94 9.408s.25.99.664 1.18c0 0 1.928.8 1.987 2.252Z"
                        fill="#236120"
                    />
                    <path
                        d="M30.634 19.99v20.314s.208 2.59-2.187 2.59H24.43V5.99h2.118v.569s-.506.359-.506.59l1.94 9.408s.25.99.664 1.18c0 0 1.928.8 1.987 2.252Z"
                        fill="#215C1F"
                    />
                    <path
                        d="M21.436 19.008c-.108.797-.442 1.564-.442 2.368v21.517h-1.59V21.281c0-.744.165-1.492.615-2.084.385-.507.875-.984 1.24-.755.175.11.21.325.177.566ZM22.89 10.698a5.09 5.09 0 0 0-.163 1.015c-.084 1.481-.362 5.65-.835 5.65-1.058 0 .078-6.676.263-7.727.017-.095.03-.186.044-.282.076-.51.385-2.205 1.13-2.205.448 0-.154 2.466-.44 3.55Z"
                        fill="#7BC47B"
                    />
                    <path
                        d="M19.404 26.228c0-.948.77-1.717 1.718-1.717h5.756c.949 0 1.718.769 1.718 1.717v7.8c0 .948-.77 1.717-1.718 1.717h-5.756a1.718 1.718 0 0 1-1.718-1.718v-7.799Z"
                        fill="#5F2478"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.122 23.939h5.756a2.29 2.29 0 0 1 2.29 2.29v7.798a2.29 2.29 0 0 1-2.29 2.29h-5.756a2.29 2.29 0 0 1-2.29-2.29V26.23a2.29 2.29 0 0 1 2.29-2.29Zm0 .572c-.948 0-1.717.769-1.717 1.718v7.798c0 .95.769 1.718 1.717 1.718h5.756c.95 0 1.718-.769 1.718-1.718V26.23c0-.949-.769-1.718-1.718-1.718h-5.756Z"
                        fill="#fff"
                    />
                    <path
                        d="M20.426 27.25c0-.949.769-1.718 1.717-1.718h3.714c.949 0 1.718.77 1.718 1.718v5.756c0 .949-.77 1.718-1.718 1.718h-3.714a1.718 1.718 0 0 1-1.717-1.718V27.25Z"
                        fill="#fff"
                    />
                    <path d="M17.362 28.596h13.276v3.064H17.362v-3.064Z" fill="#5F2478" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M30.638 29.617H17.362v-.143h13.276v.143ZM30.638 30.638H17.362v-.143h13.276v.143Z"
                        fill="#fff"
                    />
                    <path
                        d="M20.936 5.306c0-.11.09-.2.2-.2h5.728c.11 0 .2.09.2.2v.722a.1.1 0 0 1-.1.1h-5.927a.1.1 0 0 1-.1-.1v-.722Z"
                        fill="#BABABA"
                    />
                </svg>
            );
        case 'beer-pint':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path
                        d="M32.957 16.962c-.005-1.951-.08-7.067-1.422-9.346-.33-.662-.7-.937-2.113-.937H19.406c-1.422 0-1.782.275-2.114.937-1.47 2.09-1.533 7.183-1.421 9.378 0 7.356 2.651 7.526 2.651 13.565 0 2.966-1.178 5.392-1.178 7.494 0 2.029.442 2.247 2.135 2.247h9.87c1.693 0 2.135-.235 2.135-2.256 0-2.101-1.178-4.502-1.178-7.47 0-6.038 2.65-6.256 2.65-13.613Z"
                        fill="#F4B740"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M33.978 16.96v.002c0 3.841-.702 5.863-1.393 7.667l-.098.254c-.617 1.6-1.16 3.012-1.16 5.693 0 1.353.268 2.594.56 3.822l.08.33c.262 1.084.538 2.228.538 3.317 0 .53-.028 1.01-.12 1.426-.094.426-.272.854-.624 1.194-.353.341-.778.495-1.173.57-.381.074-.81.087-1.24.087h-9.869c-.429 0-.856-.012-1.235-.083-.393-.073-.819-.224-1.174-.563-.355-.34-.534-.769-.628-1.194-.092-.416-.12-.898-.12-1.429 0-1.089.276-2.237.538-3.326l.079-.332c.293-1.235.562-2.482.562-3.836 0-2.678-.544-4.08-1.16-5.667l-.098-.253c-.69-1.789-1.39-3.794-1.394-7.619-.056-1.137-.068-2.999.123-4.858.183-1.783.57-3.784 1.44-5.069.21-.402.512-.833 1.079-1.11.53-.26 1.175-.325 1.915-.325h10.016c.737 0 1.38.065 1.91.324.584.285.89.732 1.1 1.147.783 1.349 1.145 3.382 1.331 5.179.193 1.86.213 3.668.215 4.652Zm-2.443-9.343c1.342 2.279 1.417 7.394 1.422 9.345 0 3.86-.73 5.755-1.424 7.556-.629 1.632-1.228 3.187-1.228 6.058 0 1.61.348 3.055.665 4.374.268 1.111.514 2.135.514 3.095 0 2.021-.442 2.256-2.136 2.256h-9.869c-1.694 0-2.136-.219-2.136-2.248 0-.96.247-1.988.514-3.105.317-1.326.665-2.778.665-4.389 0-2.87-.6-4.414-1.228-6.035-.694-1.789-1.424-3.67-1.424-7.53-.111-2.194-.048-7.287 1.422-9.377.331-.663.692-.938 2.114-.938h10.016c1.414 0 1.782.275 2.113.938Z"
                        fill="#F5F5F5"
                    />
                    <path
                        d="M17.292 7.616c.331-.662.692-.937 2.114-.937h5.283v33.62h-5.21c-1.693 0-2.135-.218-2.135-2.246 0-2.102 1.178-4.527 1.178-7.494 0-6.039-2.651-6.209-2.651-13.565-.112-2.195-.049-7.288 1.421-9.378Z"
                        fill="#EFAC29"
                    />
                    <circle cx="18.075" cy="11.088" fill="#FFDFB9" r=".551" />
                    <circle cx="18.626" cy="13.293" fill="#FFDFB9" r=".551" />
                    <circle cx="23.036" cy="12.191" r=".551" fill="#FFDFB9" />
                    <circle cx="28.547" cy="12.742" fill="#FFF6EC" r=".551" />
                    <circle cx="30.201" cy="14.947" fill="#FFF6EC" r=".551" />
                    <circle cx="25.792" cy="13.293" fill="#FFF6EC" r=".551" />
                    <circle cx="27.445" cy="11.088" fill="#FFF6EC" r=".551" />
                    <circle cx="30.752" cy="11.088" r=".551" fill="#FFF6EC" />
                    <circle cx="20.831" cy="11.088" fill="#FFDFB9" r=".551" />
                    <circle cx="20.831" cy="14.395" r=".551" fill="#FFDFB9" />
                    <path
                        d="M30.466 6.679H18.512c-.61 0-1.153.34-1.392.9-.397.93-.818 2.118-.974 3.509h16.418a13.939 13.939 0 0 0-.927-3.642c-.192-.48-.654-.767-1.17-.767ZM17.362 38.809H31.66v1.386c-1.006.693-12.569 1.04-14.077 0l-.221-1.386Z"
                        fill="#F5F5F5"
                    />
                </svg>
            );
        case 'small-glass-wine':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path fill="#9F7CAE" d="M23.246 21.002h1.618v15.374h-1.618z" />
                    <path
                        d="M16.324 10.213h15.508s3.575 15.374-7.686 15.374c-11.262 0-7.822-15.374-7.822-15.374Z"
                        fill="#EFE9F1"
                    />
                    <path d="M16.324 16.192h15.509s0 9.394-7.687 9.394-7.822-9.394-7.822-9.394Z" fill="#5F2478" />
                    <path
                        d="M16.701 16.193h1.62c.249 0 0 1.246 1.246 4.734 1.245 3.488 5.606 3.643 5.481 3.862-.498.872-6.14-1.225-6.956-2.81-.817-1.584-1.994-5.786-1.39-5.786Z"
                        fill="#330546"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17.152 11.21c-.063.388-.137.903-.198 1.506-.142 1.396-.214 3.23.044 5.043.26 1.823.84 3.53 1.924 4.77 1.052 1.2 2.662 2.061 5.224 2.061 2.56 0 4.16-.86 5.198-2.058 1.071-1.236 1.636-2.941 1.88-4.764.243-1.813.155-3.647 0-5.043a25.372 25.372 0 0 0-.213-1.515H17.152Zm14.68-.997H16.325s-3.44 15.374 7.822 15.374c11.261 0 7.686-15.374 7.686-15.374Z"
                        fill="#9F7CAE"
                    />
                    <ellipse cx="23.936" cy="36.638" rx="7.277" ry="1.149" fill="#9F7CAE" />
                </svg>
            );
        case 'large-glass-wine':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path fill="#9F7CAE" d="M23.53 22.977h1.526v14.499H23.53z" />
                    <path d="M15.412 9.191H33.02s4.058 16.615-8.728 16.615-8.88-16.615-8.88-16.615Z" fill="#EFE9F1" />
                    <path
                        d="M15.139 15.692h17.77s.283 9.752-8.668 9.752c-8.95 0-9.102-9.752-9.102-9.752Z"
                        fill="#5F2478"
                    />
                    <path
                        d="M15.572 15.693h1.866c.287 0 .012 1.237 1.447 4.973 1.434 3.737 6.427 3.889 6.313 4.137-.674 1.458-7.181-.743-8.011-3.01-.83-2.267-2.31-6.1-1.615-6.1Z"
                        fill="#330546"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.231 10.188a25.976 25.976 0 0 0-.239 1.705c-.161 1.51-.243 3.495.051 5.458.295 1.97.955 3.829 2.201 5.184 1.217 1.324 3.09 2.274 6.048 2.274 2.959 0 4.82-.95 6.02-2.27 1.232-1.353 1.875-3.208 2.152-5.18.275-1.961.175-3.946 0-5.457a26.104 26.104 0 0 0-.256-1.714H16.231Zm16.789-.997H15.412s-3.906 16.615 8.88 16.615c12.786 0 8.728-16.615 8.728-16.615Z"
                        fill="#9F7CAE"
                    />
                    <ellipse cx="24.181" cy="37.725" rx="6.862" ry="1.084" fill="#9F7CAE" />
                </svg>
            );
        case 'wine-bottle':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path
                        d="M30.634 18.084v22.2s.207 2.61-2.187 2.61h-8.893c-2.394 0-2.188-2.61-2.188-2.61v-22.2c.06-1.463 1.987-2.27 1.987-2.27.414-.19 2.263-1.189 2.263-1.189l.148-7.856c0-.233-.42-.488-.42-.488v-.433a.14.14 0 0 1 .14-.14h.469c.03 0 .056-.024.056-.055v-.407a.14.14 0 0 1 .139-.14h3.704a.14.14 0 0 1 .14.14v.407c0 .03.025.056.055.056h.47a.14.14 0 0 1 .138.139v.433s-.254.255-.254.488v7.856s1.832.998 2.246 1.19c0 0 1.928.806 1.987 2.269Z"
                        fill="#330546"
                    />
                    <path
                        d="M21.912 18.497c.012.946-.567 1.83-.567 2.777v21.62h-1.992V21.167c0-.88.235-1.766.849-2.396.469-.482 1.042-.904 1.474-.684.169.086.233.235.236.41Z"
                        fill="#BFA7C9"
                    />
                    <path
                        d="M19.353 25.286c0-.471.382-.853.854-.853h7.586c.471 0 .854.382.854.853v9.254a.854.854 0 0 1-.854.854h-7.586a.854.854 0 0 1-.854-.854v-9.254Z"
                        fill="#5F2478"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.207 23.863h7.586c.786 0 1.423.637 1.423 1.423v9.254c0 .786-.637 1.423-1.423 1.423h-7.586a1.423 1.423 0 0 1-1.423-1.423v-9.254c0-.786.637-1.423 1.423-1.423Zm0 .57a.854.854 0 0 0-.854.853v9.254c0 .471.382.854.854.854h7.586a.854.854 0 0 0 .854-.854v-9.254a.854.854 0 0 0-.854-.854h-7.586Z"
                        fill="#fff"
                    />
                    <path
                        d="M20.017 25.863c0-.471.382-.853.854-.853h6.258c.472 0 .854.382.854.853v8.1a.854.854 0 0 1-.854.854h-6.258a.854.854 0 0 1-.854-.854v-8.1Z"
                        fill="#fff"
                    />
                    <path
                        d="M21.732 6.686a.14.14 0 0 1 .14-.137h4.423a.14.14 0 0 1 .14.14l-.031 7.937h-4.787l.115-7.94Z"
                        fill="#5F2478"
                    />
                    <path
                        opacity=".25"
                        d="M30.634 18.084v22.2s.208 2.61-2.187 2.61H24.43V5.106h1.421a.14.14 0 0 1 .14.14v.407c0 .03.025.056.055.056h.47a.14.14 0 0 1 .139.139v.433s-.255.255-.255.488v7.856s1.832.998 2.246 1.19c0 0 1.928.806 1.987 2.269Z"
                        fill="#330546"
                    />
                </svg>
            );
        case 'spirits-shot':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path
                        d="M15.478 15.093a.665.665 0 0 1 .655-.795h16.075c.421 0 .737.383.654.796l-3.82 19.1a.66.66 0 0 1-.652.53h-8.438a.681.681 0 0 1-.657-.549c-2.616-13.08-3.51-17.553-3.817-19.082Z"
                        fill="#EFE9F1"
                    />
                    <path
                        d="M17.378 19.045a.64.64 0 0 1 .65-.662h12.284a.64.64 0 0 1 .65.662c-.064 1.715-.38 6.758-1.924 15.13a.67.67 0 0 1-.655.548h-8.425a.67.67 0 0 1-.655-.548c-1.544-8.372-1.86-13.415-1.925-15.13Z"
                        fill="#5F2478"
                    />
                    <path
                        d="M17.362 18.383h2.496c.265 0 1.309 4.213 1.702 6.128.394 1.915 2.146 9.202 1.703 9.646-1.362 1.361-3.859-2.157-4.457-8.115-.598-5.96-2.085-7.659-1.444-7.659Z"
                        fill="#330546"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m16.94 15.627 3.554 17.767h7.353L31.4 15.628H16.94Zm-.79-1.33a.68.68 0 0 0-.668.814l3.81 19.053a.7.7 0 0 0 .675.56h8.404a.702.702 0 0 0 .677-.56l3.81-19.053a.68.68 0 0 0-.667-.813H16.15Z"
                        fill="#BFA7C9"
                    />
                    <rect x="19.404" y="30.639" width="9.532" height="4.085" rx=".667" fill="#BFA7C9" />
                </svg>
            );
        case 'small-spirits-bottle':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path
                        d="m30.575 18.933-2.03 22.528H19.392l-2.03-22.528c.059-1.328 1.979-2.06 1.979-2.06.412-.174 2.253-1.08 2.253-1.08l.148-7.134c0-.211-.418-.443-.418-.443v-.381c0-.077.062-.139.139-.139h.467c.03 0 .055-.025.055-.055v-.353c0-.076.062-.139.139-.139h3.689c.077 0 .139.063.139.14v.352c0 .03.025.055.055.055h.467c.077 0 .139.062.139.139v.381s-.254.232-.254.443v7.134s1.825.906 2.237 1.08c0 0 1.92.732 1.979 2.06Z"
                        fill="#BFA7C9"
                    />
                    <path
                        d="M20.862 17.538c.761.756-.43 2.078-.386 3.15l.848 20.773h-.916l-1.836-20.772c-.095-1.072.152-2.207.998-2.872.397-.312.827-.52 1.17-.362.049.023.09.051.122.084Z"
                        fill="#9F7CAE"
                    />
                    <path
                        d="M20.409 20.817c0-.378.307-.685.685-.685h6.094c.379 0 .686.307.686.685v6.657a.686.686 0 0 1-.686.685h-6.094a.686.686 0 0 1-.685-.685v-6.657Z"
                        fill="#5F2478"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.095 19.675h6.093c.631 0 1.143.511 1.143 1.143v6.656c0 .63-.512 1.142-1.143 1.142h-6.093a1.143 1.143 0 0 1-1.143-1.142v-6.656c0-.632.511-1.143 1.142-1.143Zm0 .457a.686.686 0 0 0-.686.686v6.656c0 .378.307.685.686.685h6.093a.686.686 0 0 0 .686-.685v-6.656a.686.686 0 0 0-.686-.686h-6.093Z"
                        fill="#fff"
                    />
                    <rect x="20.942" y="20.555" width="6.398" height="7.182" rx=".671" fill="#fff" />
                    <path
                        d="M21.71 8.596a.139.139 0 0 1 .138-.137h4.406c.077 0 .14.062.139.14l-.03 7.194h-4.768l.114-7.197Z"
                        fill="#5F2478"
                    />
                    <path
                        opacity=".25"
                        d="m30.575 18.933-2.03 22.528h-4.148V7.149h1.416c.077 0 .139.063.139.14v.352c0 .03.024.055.055.055h.467c.077 0 .139.062.139.139v.381s-.254.232-.254.443v7.134s1.825.906 2.237 1.08c0 0 1.92.732 1.979 2.06Z"
                        fill="#5F2478"
                    />
                </svg>
            );
        case 'large-spirits-bottle':
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 8.17A8.17 8.17 0 0 1 8.17 0h31.66A8.17 8.17 0 0 1 48 8.17v31.66A8.17 8.17 0 0 1 39.83 48H8.17A8.17 8.17 0 0 1 0 39.83V8.17Z"
                        fill="#BEE6E9"
                    />
                    <path
                        d="M31.65 18.084 29.3 42.894H18.692l-2.352-24.81c.069-1.463 2.293-2.27 2.293-2.27.478-.19 2.612-1.189 2.612-1.189l.17-7.856c0-.233-.484-.488-.484-.488v-.433a.14.14 0 0 1 .14-.14h.57c.031 0 .056-.024.056-.055v-.407a.14.14 0 0 1 .14-.14h4.317a.14.14 0 0 1 .14.14v.407c0 .03.024.056.055.056h.571a.14.14 0 0 1 .14.139v.433s-.294.255-.294.488v7.856s2.114.998 2.592 1.19c0 0 2.225.806 2.293 2.269Z"
                        fill="#BFA7C9"
                    />
                    <path
                        d="M20.466 16.635c.566.964-.569 2.172-.52 3.29l.985 22.969h-1.06L17.735 19.93c-.104-1.12.177-2.294 1.058-2.993.488-.387 1.034-.669 1.46-.48.101.044.17.105.213.178Z"
                        fill="#9F7CAE"
                    />
                    <path
                        d="M19.87 20.093c0-.38.309-.689.69-.689h7.272c.38 0 .688.309.688.689v7.463c0 .38-.308.689-.688.689h-7.273a.688.688 0 0 1-.688-.689v-7.463Z"
                        fill="#5F2478"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.56 18.945h7.272c.633 0 1.147.514 1.147 1.148v7.463c0 .634-.514 1.148-1.147 1.148h-7.273a1.148 1.148 0 0 1-1.147-1.148v-7.463c0-.634.513-1.148 1.147-1.148Zm0 .46a.689.689 0 0 0-.69.688v7.463c0 .38.309.689.69.689h7.272c.38 0 .688-.308.688-.689v-7.463a.689.689 0 0 0-.688-.689h-7.273Z"
                        fill="#fff"
                    />
                    <rect x="20.488" y="19.87" width="7.414" height="7.91" rx=".674" fill="#fff" />
                    <path
                        d="M21.378 6.686a.14.14 0 0 1 .14-.137h5.147a.14.14 0 0 1 .14.14l-.036 7.937h-5.523l.132-7.94Z"
                        fill="#5F2478"
                    />
                    <path
                        opacity=".25"
                        d="M31.65 18.084 29.3 42.894h-4.806V5.106h1.661a.14.14 0 0 1 .14.14v.407c0 .03.024.056.055.056h.571a.14.14 0 0 1 .14.139v.433s-.294.255-.294.488v7.856s2.114.998 2.592 1.19c0 0 2.225.806 2.293 2.269Z"
                        fill="#5F2478"
                    />
                </svg>
            );
        case 'full-star':
            return (
                <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.0925 2.2218C15.4497 1.4463 16.5518 1.4463 16.909 2.2218L20.4389 9.88494C20.5844 10.2009 20.8838 10.4186 21.2292 10.4596L29.5997 11.4537C30.4467 11.5542 30.7871 12.6008 30.1613 13.1804L23.971 18.9135C23.716 19.1496 23.6019 19.501 23.6696 19.8418L25.313 28.1225C25.4791 28.9597 24.5877 29.6068 23.8432 29.1895L16.4897 25.0678C16.1859 24.8976 15.8155 24.8976 15.5118 25.0678L8.15828 29.1895C7.41376 29.6068 6.52232 28.9597 6.68847 28.1225L8.33188 19.8419C8.39952 19.5011 8.28539 19.1496 8.03044 18.9135L1.83904 13.1804C1.2132 12.6009 1.55356 11.5542 2.40055 11.4537L10.7722 10.4596C11.1177 10.4186 11.417 10.2009 11.5626 9.88493L15.0925 2.2218Z"
                        fill="#FFEF8F"
                        stroke="#FFD500"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            );
        case 'circle-star':
            return (
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20 39.8438C30.8984 39.8438 39.9219 30.8008 39.9219 19.9219C39.9219 9.02344 30.8789 0 19.9805 0C9.10156 0 0.078125 9.02344 0.078125 19.9219C0.078125 30.8008 9.12109 39.8438 20 39.8438ZM20 36.5234C10.7812 36.5234 3.41797 29.1406 3.41797 19.9219C3.41797 10.7031 10.7617 3.32031 19.9805 3.32031C29.1992 3.32031 36.582 10.7031 36.6016 19.9219C36.6211 29.1406 29.2188 36.5234 20 36.5234ZM14.375 30L19.9805 25.8789L25.5859 30C26.7383 30.8594 27.9297 29.9609 27.5 28.6328L25.2734 22.0117L30.9375 17.9688C31.9727 17.207 31.6602 15.6836 30.2148 15.7031L23.2617 15.7617L21.1328 9.10156C20.7227 7.8125 19.2383 7.8125 18.8281 9.10156L16.6992 15.7617L9.74609 15.7031C8.32031 15.6836 7.96875 17.1875 9.02344 17.9688L14.6875 22.0117L12.4805 28.6328C12.0312 29.9609 13.2422 30.8594 14.375 30Z"
                        fill="#5F2478"
                    />
                </svg>
            );
        case 'half-star':
            return (
                <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.0925 2.2218C15.4497 1.4463 16.5518 1.4463 16.909 2.2218L20.4389 9.88494C20.5844 10.2009 20.8838 10.4186 21.2292 10.4596L29.5997 11.4537C30.4467 11.5542 30.7871 12.6008 30.1613 13.1804L23.971 18.9135C23.716 19.1496 23.6019 19.501 23.6696 19.8418L25.313 28.1225C25.4791 28.9597 24.5877 29.6068 23.8432 29.1895L16.4897 25.0678C16.1859 24.8976 15.8155 24.8976 15.5118 25.0678L8.15828 29.1895C7.41376 29.6068 6.52232 28.9597 6.68847 28.1225L8.33188 19.8419C8.39952 19.5011 8.28539 19.1496 8.03044 18.9135L1.83904 13.1804C1.2132 12.6009 1.55356 11.5542 2.40055 11.4537L10.7722 10.4596C11.1177 10.4186 11.417 10.2009 11.5626 9.88493L15.0925 2.2218Z"
                        stroke="#FFD500"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            );
        case 'chevron-white-right':
            return (
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m1 11.5 5-5-5-5" stroke="#FFF" strokeWidth="2" />
                </svg>
            );
        case 'chevron-purple-left':
            return (
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.636 2.323c.485.484.485 1.27 0 1.755L6.551 9.164l5.085 5.086a1.242 1.242 0 1 1-1.755 1.755l-5.964-5.963a1.242 1.242 0 0 1 0-1.756l5.964-5.963a1.242 1.242 0 0 1 1.755 0Z"
                        fill="#5F2478"
                    />
                </svg>
            );
        case 'chevron-black-down':
            return (
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m1 1.5 5 5 5-5" stroke="#000" strokeWidth="2" />
                </svg>
            );
        case 'dark-bell':
            return (
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.511 9.241V7.56c0-2.455-1.65-4.536-3.911-5.215v-.762C9.6.71 8.882 0 8 0c-.882 0-1.6.71-1.6 1.582v.762c-2.261.68-3.911 2.76-3.911 5.215V9.24c0 2.156-.831 4.201-2.34 5.757a.523.523 0 0 0-.106.572c.084.194.277.32.49.32h4.854A2.664 2.664 0 0 0 8 18a2.664 2.664 0 0 0 2.613-2.11h4.854a.533.533 0 0 0 .49-.32.523.523 0 0 0-.105-.572 8.231 8.231 0 0 1-2.34-5.757ZM7.467 1.582c0-.29.239-.527.533-.527.294 0 .533.236.533.527v.553a5.616 5.616 0 0 0-1.066 0v-.553ZM8 16.945c-.695 0-1.288-.44-1.508-1.054h3.016A1.601 1.601 0 0 1 8 16.945Zm-6.317-2.11a9.255 9.255 0 0 0 1.873-5.594V7.56c0-2.424 1.993-4.395 4.444-4.395 2.45 0 4.444 1.971 4.444 4.395V9.24c0 2.037.658 3.985 1.873 5.595H1.683Z"
                        fill="#000"
                    />
                </svg>
            );
        case 'burger':
            return (
                <svg width="106" height="100" viewBox="0 0 106 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.6374 27.4487H95.6921C96.2424 40.2894 94.4639 49.3873 89.2279 57.2486C84.008 67.1366 87.7621 75.129 95.6921 84.7682H10.6374C6.91501 71.9051 8.22035 63.0826 15.1046 56.1085C19.829 47.3841 18.7497 38.699 10.6374 27.4487Z"
                        fill="#FFC700"
                    />
                    <rect x="3.90967" y="44.9751" width="94.7946" height="13.5421" rx="6.77104" fill="#8C5412" />
                    <rect x="3.90967" y="61.9028" width="94.7946" height="13.5421" rx="6.77104" fill="#8C5412" />
                    <path
                        d="M3.90967 51.7461C3.90967 48.0066 6.94117 44.9751 10.6807 44.9751H54.6925V58.5172H10.6807C6.94116 58.5172 3.90967 55.4857 3.90967 51.7461Z"
                        fill="#7A4200"
                    />
                    <path
                        d="M3.90967 68.6739C3.90967 64.9343 6.94117 61.9028 10.6807 61.9028H54.6925V75.4449H10.6807C6.94116 75.4449 3.90967 72.4134 3.90967 68.6739Z"
                        fill="#7A4200"
                    />
                    <path
                        d="M84.0813 41.9805H55.5808C55.5808 41.9805 51.5912 43.3931 55.5808 48.5782C59.5704 53.7632 88.1998 53.7862 84.0813 48.5782C79.9628 43.3701 84.0813 41.9805 84.0813 41.9805Z"
                        fill="#32B137"
                    />
                    <path
                        d="M18.7639 41.1733H52.5145C52.5145 41.1733 57.239 42.6946 52.5145 48.2786C47.79 53.8625 13.8867 53.8872 18.7639 48.2786C23.6411 42.6699 18.7639 41.1733 18.7639 41.1733Z"
                        fill="#08930D"
                    />
                    <ellipse cx="37.635" cy="42.9441" rx="16.9276" ry="3.38552" fill="#C70A0A" />
                    <ellipse cx="71.5425" cy="42.9441" rx="16.9276" ry="3.38552" fill="#DD0E0E" />
                    <rect x="3.90967" y="29.6621" width="94.7946" height="13.5421" rx="6.77104" fill="#8C5412" />
                    <rect x="3.90967" y="29.6621" width="50.7828" height="13.5421" fill="#7A4200" />
                    <path
                        d="M105.475 84.6718C105.475 63.0317 81.9813 74.064 52.9999 74.064C24.0184 74.064 0.524292 63.0317 0.524292 84.6718C0.524292 96.7705 24.0184 96.7705 52.9999 96.7705C81.9813 96.7705 105.475 96.7705 105.475 84.6718Z"
                        fill="#E8A804"
                    />
                    <path
                        d="M0.524292 84.6718C0.524292 63.0317 24.0184 74.064 52.9998 74.064C53.5662 74.064 54.1305 74.0598 54.6926 74.0517V96.7704L52.9998 96.7705C24.0184 96.7705 0.524292 96.7705 0.524292 84.6718Z"
                        fill="#D99D03"
                    />
                    <path
                        d="M105.475 39.1828C105.475 60.8229 90.2406 33.8552 54.6926 33.8552C19.1447 33.8552 0.524292 60.8229 0.524292 39.1828C0.524292 17.5428 24.2229 0 54.6926 0C85.1623 0 105.475 17.5428 105.475 39.1828Z"
                        fill="#E8A804"
                    />
                    <path
                        d="M54.6926 33.8552C19.1447 33.8552 0.524292 60.8229 0.524292 39.1828C0.524292 17.5428 24.2229 0 54.6926 0V33.8552Z"
                        fill="#D99D03"
                    />
                    <circle cx="29.3013" cy="8.46424" r="1.69276" fill="#B58200" />
                    <circle cx="39.4579" cy="5.07801" r="1.69276" fill="#B58200" />
                    <circle cx="66.5416" cy="5.07801" r="1.69276" fill="#B58200" />
                    <circle cx="59.7713" cy="15.2348" r="1.69276" fill="#B58200" />
                    <circle cx="46.2288" cy="15.2348" r="1.69276" fill="#B58200" />
                    <circle cx="32.6867" cy="18.6205" r="1.69276" fill="#B58200" />
                    <circle cx="76.6989" cy="8.46424" r="1.69276" fill="#B58200" />
                    <circle cx="53" cy="5.07801" r="1.69276" fill="#B58200" />
                    <circle cx="73.313" cy="18.6205" r="1.69276" fill="#B58200" />
                </svg>
            );
        case 'phone':
            return (
                <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M39.6889 30.3095L33.4675 29.5992C31.9733 29.4278 30.5037 29.9421 29.4505 30.9954L24.9436 35.5022C18.0119 31.9751 12.3294 26.317 8.80225 19.3608L13.3336 14.8295C14.3868 13.7762 14.9012 12.3066 14.7297 10.8125L14.0194 4.64008C13.7255 2.16621 11.6435 0.304688 9.14517 0.304688H4.90775C2.13995 0.304688 -0.162458 2.6071 0.00899772 5.37489C1.30717 26.2926 18.0364 42.9973 38.9296 44.2955C41.6974 44.4669 43.9998 42.1645 43.9998 39.3967V35.1593C44.0243 32.6854 42.1627 30.6035 39.6889 30.3095Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'calendar':
            return (
                <svg width="34" height="37" viewBox="0 0 34 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M24.3333 16.6387H9.66667C8.65833 16.6387 7.83333 17.4637 7.83333 18.472C7.83333 19.4803 8.65833 20.3053 9.66667 20.3053H24.3333C25.3417 20.3053 26.1667 19.4803 26.1667 18.472C26.1667 17.4637 25.3417 16.6387 24.3333 16.6387ZM29.8333 3.80534H28V1.97201C28 0.963672 27.175 0.138672 26.1667 0.138672C25.1583 0.138672 24.3333 0.963672 24.3333 1.97201V3.80534H9.66667V1.97201C9.66667 0.963672 8.84167 0.138672 7.83333 0.138672C6.825 0.138672 6 0.963672 6 1.97201V3.80534H4.16667C2.13167 3.80534 0.5 5.45534 0.5 7.47201V33.1387C0.5 35.1553 2.13167 36.8053 4.16667 36.8053H29.8333C31.85 36.8053 33.5 35.1553 33.5 33.1387V7.47201C33.5 5.45534 31.85 3.80534 29.8333 3.80534ZM28 33.1387H6C4.99167 33.1387 4.16667 32.3137 4.16667 31.3053V12.972H29.8333V31.3053C29.8333 32.3137 29.0083 33.1387 28 33.1387ZM18.8333 23.972H9.66667C8.65833 23.972 7.83333 24.797 7.83333 25.8053C7.83333 26.8137 8.65833 27.6387 9.66667 27.6387H18.8333C19.8417 27.6387 20.6667 26.8137 20.6667 25.8053C20.6667 24.797 19.8417 23.972 18.8333 23.972Z"
                        fill="currentColor"
                    />
                </svg>
            );
        default:
            return name;
    }
};

Icon.propTypes = {
    /**
     * Text of heading
     */
    name: PropTypes.oneOf([
        'timer',
        'secure',
        'questions',
        'info-round',
        'tick-round',
        'tick',
        'small-tick',
        'move-more',
        'lose-weight',
        'quit-smoking',
        'drink-less',
        'move-more-round',
        'lose-weight-round',
        'quit-smoking-round',
        'drink-less-round',
        'form-error',
        'loading',
        'chevron',
        'nav-button',
        'exit-button',
        'minus',
        'plus',
        'beer-bottle',
        'beer-pint',
        'small-glass-wine',
        'large-glass-wine',
        'wine-bottle',
        'spirits-shot',
        'small-spirits-bottle',
        'large-spirits-bottle',
        'full-star',
        'half-star',
        'chevron-white-right',
        'chevron-purple-left',
        'chevron-black-down',
        'dark-bell',
        'burger',
        'phone',
        'calendar',
        'circle-star',
    ]).isRequired,
};

Icon.defaultProps = {};
